import axios from "axios";
import React, { useRef, useState } from "react";

export  const CameraSettings: React.FC = () => {
  const [peer, setPeer] = useState<RTCPeerConnection | null>(null);
  const videoRef = useRef<HTMLVideoElement>(null);

  const init = async () => {
    const peer = createPeer();
    peer.addTransceiver("video", { direction: "recvonly" });
    setPeer(peer);
  };

  const createPeer = () => {
    const peer = new RTCPeerConnection({
      iceServers: [
        {
          urls: "stun:stun.stunprotocol.org",
        },
      ],
    });
    peer.ontrack = handleTrackEvent;
    peer.onnegotiationneeded = () => handleNegotiationNeededEvent(peer);

    return peer;
  };

  const handleNegotiationNeededEvent = async (peer: RTCPeerConnection) => {
    const offer = await peer.createOffer();
    await peer.setLocalDescription(offer);
    const payload = {
      sdp: peer.localDescription,
    };

    try {
      const { data } = await axios.post(
        "http://192.168.1.20:5001/consumer",
        payload
      );
      const desc = new RTCSessionDescription(data.sdp);
      peer.setRemoteDescription(desc).catch((e) => console.log(e));
    } catch (error) {
      console.error("Error posting to /consumer:", error);
    }
  };

  const handleTrackEvent = (e: RTCTrackEvent) => {
    if (videoRef.current) {
      videoRef.current.srcObject = e.streams[0];
    }
  };

  return (
    <div className="mt-4">
      <button id="my-button" onClick={init}>
        Start Connection
      </button>
      {peer && <video ref={videoRef} autoPlay playsInline width="640" height="480"></video>}
    
    </div>
  );
};


